import {useSyncExternalStore} from 'react';

type Stage = 'hidden' | 'toast' | 'modal';

const COOLDOWN_MS = 4000;

let stage: Stage = 'hidden';
let cooldownUntil = 0;
// Reseta apenas quando o app é reaberto do zero (estado de módulo não
// sobrevive a um cold start), garantindo no máximo um toast por sessão.
let hasShownThisSession = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(listener => listener());
}

export function showFinesToast() {
  if (hasShownThisSession) {return;}
  if (stage !== 'hidden') {return;}
  if (Date.now() < cooldownUntil) {return;}
  hasShownThisSession = true;
  stage = 'toast';
  emit();
}

// Abre o modal direto de qualquer estágio (toque no toast, ou toque num card
// fixo em outra tela) — só o cooldown de showFinesToast() é ignorado aqui de
// propósito, já que um toque explícito do usuário não deve ser bloqueado.
export function openFinesModal() {
  if (stage === 'modal') {return;}
  stage = 'modal';
  emit();
}

export function closeFinesFlow() {
  if (stage === 'hidden') {return;}
  stage = 'hidden';
  cooldownUntil = Date.now() + COOLDOWN_MS;
  emit();
}

export function useFinesFlowStage() {
  return useSyncExternalStore(
    listener => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => stage,
  );
}
